import { render, staticRenderFns } from "./IconUserProfile.vue?vue&type=template&id=d43247ea&scoped=true"
import script from "./IconUserProfile.vue?vue&type=script&lang=js"
export * from "./IconUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43247ea",
  null
  
)

export default component.exports